var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12 17.6435 12.7375 15.863 14.0503 14.5503C15.363 13.2375 17.1435 12.5 19 12.5H61C62.8565 12.5 64.637 13.2375 65.9497 14.5503C67.2625 15.863 68 17.6435 68 19.5V61.5C68 63.3565 67.2625 65.137 65.9497 66.4497C64.637 67.7625 62.8565 68.5 61 68.5H19C17.1435 68.5 15.363 67.7625 14.0503 66.4497C12.7375 65.137 12 63.3565 12 61.5V19.5ZM64.5 26.5H50.5V37H64.5V26.5ZM64.5 40.5H50.5V51H64.5V40.5ZM64.5 54.5H50.5V65H61C61.9283 65 62.8185 64.6312 63.4749 63.9749C64.1312 63.3185 64.5 62.4283 64.5 61.5V54.5ZM47 65V54.5H33V65H47ZM29.5 65V54.5H15.5V61.5C15.5 62.4283 15.8687 63.3185 16.5251 63.9749C17.1815 64.6312 18.0717 65 19 65H29.5ZM15.5 51H29.5V40.5H15.5V51ZM15.5 37H29.5V26.5H15.5V37ZM33 26.5V37H47V26.5H33ZM47 40.5H33V51H47V40.5Z",
    fill: "#2F64F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.54d67cb6bff492fe7d547d97b398023e.svg";
export { ForwardRef as ReactComponent };